// extracted by mini-css-extract-plugin
export default {"SpinnerWrapper":"spinner_SpinnerWrapper__bc5d9","spin":"spinner_spin__zo8Zl"};